export default __webpack_public_path__ + "static/media/Pressure-Washers-Category-Offer.81262b96.png";